import React from 'react';
import {FieldArray} from 'formik';
import SurveyAlertsType from './SurveyAlertsType';

const SurveyAlertsForm = () => (
    <div className="form-group">
        <FieldArray name="alerts" component={SurveyAlertsType} />
    </div>
);

export default SurveyAlertsForm;
